import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, of, shareReplay, switchMap, throwError } from "rxjs";

import {
    DatabaseAnnotation,
    LiquidViewerAnnotation,
} from "../liquid-viewer.models";
import { environment } from "src/index";
import {
    LiquidViewerConverterService
} from "./liquid-viewer-services.index";

@Injectable({
    providedIn: 'root',
})
export class LiquidViewerAnnotationListService {

    httpClient = inject(HttpClient);
    liquidViewerConverterService = inject(LiquidViewerConverterService);

    loadAnnotations(mainContentId: string) {
        if (environment.getAnnotationsByCourseId && mainContentId) {
            return this.httpClient.get<DatabaseAnnotation[]>(
                environment.getAnnotationsByCourseId.replace(':id', mainContentId)
            ).pipe(
                catchError(response => throwError(() => response.error.message)),
                map(response => this.liquidViewerConverterService.convertAnnotations(response)),
                shareReplay(1),
            );
        }
        return of([]);
    }

    createAnnotation(annotation: LiquidViewerAnnotation) {
        if (environment.saveAnnotation && annotation) {
            const databaseAnnotation = this.liquidViewerConverterService.convertToDataseAnnotation(annotation);
            if (databaseAnnotation) {
                return this.httpClient.post<DatabaseAnnotation>(
                    environment.saveAnnotation, databaseAnnotation
                ).pipe(
                    catchError(response => throwError(() => response.error.message)),
                    switchMap(response => this.loadAnnotations(annotation.mainId)),
                    shareReplay(1),
                );
            }
        }
        return of([]);
    }

    updateAnnotation(annotation: LiquidViewerAnnotation) {
        if (environment.updateAnnotationById && annotation && annotation.id) {
            const databaseAnnotation = this.liquidViewerConverterService.convertToDataseAnnotation(annotation);
            return this.httpClient.put<DatabaseAnnotation>(
                environment.updateAnnotationById.replace(':annotationId', annotation.id), databaseAnnotation
            ).pipe(
                catchError(response => throwError(() => response.error.message)),
                switchMap(() => this.loadAnnotations(annotation.mainId)),
                shareReplay(1),
            );
        }
        return of([]);
    }

    deleteAnnotation(annotation: LiquidViewerAnnotation) {
        if (environment.deleteAnnotationById && annotation && annotation.id) {
            return this.httpClient.delete<DatabaseAnnotation>(
                environment.deleteAnnotationById.replace(':annotationId', annotation.id)
            ).pipe(
                catchError(response => throwError(() => response.error.message)),
                switchMap(() => this.loadAnnotations(annotation.mainId)),
                shareReplay(1),
            );
        }
        return of([]);
    }
}